'use client';

import { useEffect } from 'react';
import { useRenderErrorHandler } from '@/features/design/render/hooks/use-render-error-handler';
import { useFirstRunSession } from '../model/first-run.store';

/**
 * A render the wizard could not start is answered on the design page it
 * opened, by the Generate button's own handler (paywall or the API's message).
 */
export function FirstRunLaunchNotices({ conceptId }: { conceptId: string }) {
  const handoff = useFirstRunSession((s) => s.handoff);
  const clearHandoff = useFirstRunSession((s) => s.clearHandoff);
  const handleRenderError = useRenderErrorHandler();

  useEffect(() => {
    if (handoff?.conceptId !== conceptId) return;
    clearHandoff();
    handleRenderError(handoff.error, 'explore');
  }, [handoff, conceptId, clearHandoff, handleRenderError]);

  return null;
}
